// Mochi's weather-flavored phrase banks. Picked by morning greeting + idle
// bubble + LLM context snippets to make the avatar feel context-aware without
// going overboard.
//
// Index: WEATHER_PHRASES[condition][season] → string[]
// Falls back gracefully when a (condition × season) pair has no specific bank.

const W = {
    sunny: {
        spring: [
            "the sun is being so generous today 🌸",
            "soft spring sun. perfect rice-ball weather.",
            "look at that light. let's match its energy ☀️",
        ],
        summer: [
            "sunshine on rice ☀️ let's keep it light today.",
            "hot one out there. hydrate, mochi-style.",
            "summer sun is bossy. one small thing at a time.",
        ],
        autumn: [
            "crisp gold light today 🍂 cozy plus sun, my favorite.",
            "autumn sun is soft. lean into it.",
            "the light is doing that thing again. magical.",
        ],
        winter: [
            "winter sun!! rare. precious.",
            "cold but bright — sweater + sun day.",
            "the kind of light that pretends it's warm.",
        ],
    },
    cloudy: {
        spring: [
            "soft grey skies. spring dreaming weather 🌫️",
            "the clouds are being thoughtful today.",
            "moody-cute spring vibes.",
        ],
        summer: [
            "cloudy summer = gift mode. cooler, calmer.",
            "the sky is taking a nap. so can we, briefly.",
            "soft sky. soft start.",
        ],
        autumn: [
            "grey autumn hug from the sky 🍵",
            "moody autumn skies — perfect for inside wins.",
            "soft fog vibes. cozy mode unlocked.",
        ],
        winter: [
            "grey winter sky. blanket weather forever.",
            "the sky is doing its best impression of soup.",
            "cozy overcast. hot drink approved.",
        ],
    },
    rainy: {
        spring: [
            "spring rain! the flowers are vibing 🌧️",
            "everything is a little greener today.",
            "rain on petals. soft soundtrack.",
        ],
        summer: [
            "summer storm energy. dramatic, fun.",
            "the rain is washing the heat off. nice.",
            "rainy summer = excuse to slow down.",
        ],
        autumn: [
            "autumn rain on leaves — the actual sound of peace 🍂",
            "puddle weather. soft and grey.",
            "the kind of rain that begs for soup.",
        ],
        winter: [
            "cold rain. tea agenda is now mandatory.",
            "grey rainy winter. we move slow today.",
            "rain on the window. that's the whole vibe.",
        ],
    },
    snowy: {
        spring: [
            "snow in spring?? bold move, weather.",
            "late-season snow. surprise quiet day.",
            "the sky changed its mind. cozy bonus.",
        ],
        summer: [
            "snow in summer? are we in a snow globe ❄️",
            "weather is being weird. roll with it.",
        ],
        autumn: [
            "first snow of the year?! gentle 🍡",
            "snow + autumn leaves = unreal combo.",
            "the world just got quieter. listen.",
        ],
        winter: [
            "snow day energy 🍡✨",
            "everything is soft and white. perfect.",
            "snowflakes are doing the work. so can we, gently.",
        ],
    },
};

const GENERIC = [
    "soft day. let's start small.",
    "whatever the sky's doing, I'm in your corner.",
    "fresh morning. tiny step?",
];

export function getWeatherPhrases(condition, season) {
    return (W[condition] && W[condition][season]) || GENERIC;
}

export function pickWeatherGreeting(snapshot) {
    if (!snapshot || !snapshot.condition || !snapshot.season) return null;
    const pool = getWeatherPhrases(snapshot.condition, snapshot.season);
    return pool[Math.floor(Math.random() * pool.length)];
}

// Short label for UI chips — e.g. "Sunny spring morning".
const COND_LABEL = { sunny: "Sunny", cloudy: "Cloudy", rainy: "Rainy", snowy: "Snowy" };
const SEASON_LABEL = { spring: "spring", summer: "summer", autumn: "autumn", winter: "winter" };
export function weatherChipLabel(snapshot) {
    if (!snapshot) return null;
    const c = COND_LABEL[snapshot.condition] || "Soft";
    const s = SEASON_LABEL[snapshot.season] || "day";
    return `${c} ${s}`;
}
